import { v1ApiClient } from '@/services';
import type { PathParams } from '@/shared/api/generated';

import type { HelpscoutInfo } from '../model';

type HelpscoutPath = '/v1/workspaces/{workspace_id}/helpscout';

const normalizeMailboxIds = (mailbox_ids: number[] | null | undefined) => {
  if (!mailbox_ids) return null;
  return mailbox_ids.map(String);
};

/**
 * Helpscout 연동 정보 조회
 */
export const getHelpscoutInfo = async ({
  workspace_id,
}: PathParams<HelpscoutPath, 'get'>): Promise<HelpscoutInfo | null> => {
  try {
    const res = await v1ApiClient.get<HelpscoutInfo>(
      `/workspaces/${workspace_id}/helpscout`,
    );
    return {
      ...res.data,
      mailbox_ids: normalizeMailboxIds(
        res.data.mailbox_ids as number[] | null | undefined,
      ),
    };
  } catch {
    return null;
  }
};
